<template>
    <div>
        <div class="topYa">
            <div class="head">
                <div class="province" @click="goDizhi">
                    <van-icon name="location-o" />
                </div>
                <div class="input">
                    <div class="select-province" @click="goDizhi">{{$store.state.areaInfo.province}}</div>
                    <input class="header-search" type="text" v-model="seaValue" @input="shuru" placeholder="请输入高校名称">
                    <div class="search">
                        <Icon type="ios-search-outline" />
                    </div>
                    <div class="searchList" v-if="isSearch">
                        <ul>
                            <li
                                v-for="(item,index) in searchList"
                                :key="index"
                                @click="goSchool(item)"
                            >{{item.name}}</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <van-swipe :autoplay="3000" indicator-color="white" class="van-swipe">
            <van-swipe-item v-for="(item,index) in bannerList" :key="index" @click="goNewsDetail(item)">
                <img :src="item.ad_code" />
            </van-swipe-item>
        </van-swipe>
         <!-- 校派头条 -->
        <div class="toutiao">
            <div class="ttLeft">
                <img src="https://new.schoolpi.net/attach/small_program/index/cate_one.jpg" alt />
            </div>
            <div class="ttRight">
                <van-swipe :autoplay="3000" vertical class="swiper" :show-indicators="false">
                    <van-swipe-item
                        @click="goNews(item.id)"
                        v-for="(item,index) in topnewsList"
                        :key="index"
                    >
                        <!-- <p class="circle"></p> -->
                        <p>{{item.title}}</p>
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <!-- 首页栏目 -->
        <div class="menu">
            <div class="item" @click="goColum(item)" v-for="(item,index) in column" :key="index">
                <div class="menu-item">
                    <img :src="item.logo" alt />
                </div>
                <p>{{item.name}}</p>
            </div>
        
        </div>
       <!--  -->
        <!-- 新闻页 -->
        <van-list class="news-list"  finished-text="没有更多了"
                            @load="onLoad" :finished="finished">
                <div v-for="(item,index) in newsList" :key="index">
        <!--新闻-->
        <div v-if="item.is_information === 0">
            <!-- 早班车 -->
            <div v-if="item.earlybus === 1" class="monring">
                <div class="earlybus-info" @click="goEarly(item.id)"></div>
            </div>           
            <div v-else>
                <!-- 普通新闻 -->
                <div v-if="item.type===1">
                    <!-- 单图 -->
                    <div v-if="item.thumb.length === 1">
                        <div class="earlybus-item" @click="goNews(item.id)">
                            <div class="single-info">
                                <div class="earlybus-title">{{item.title}}</div>
                                <div class="earlybus-desc">{{item.desc}}</div>
                            </div>
                            <img class="single-img" :src="item.thumb[0]" mode="scaleToFill" />
                        </div>
                    </div>
                    <!-- 三图 -->
                    <div v-if="item.thumb.length === 3">
                        <div class="triple-item" @click="goNews(item.id)">
                            <div class="triple-title">{{item.title}}</div>
                            <div class="triple-content">
                                <div v-for="(img,index) in item.thumb" :key="index">
                                    <img class="triple-img" :src="img" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 无图 -->
                    <div v-if="item.thumb.length === 0">
                        <div class="nopic-item" @click="goNews(item.id)">
                            <div class="nopic-title">{{item.title}}</div>
                            <div class="nopic-content">{{item.desc}}</div>
                        </div>
                    </div>
                </div>
                <!-- 视频 -->
                <div v-if="item.type===2">
                    <!-- data-link="{{item.video_url}}" data-id="{{item.id}}" -->
                    <div class="vedio-item" @click="goVedio(item)" >
                        <div class="vedio-title">{{item.title}}</div>
                        <img class="vedio-img" :src="item.thumb[0]" mode="scaleToFill" />
                    </div>
                </div>
            </div>
        </div>

    </div>             
        </van-list>
    </div>
</template>
<script>

import { httpPost } from "../../axios/index";
export default {
    data() {
        return {
            bannerList: [],
            topnewsList: [], //头条
            newsList: [], //新闻
            seaValue: "", //搜索值
            searchList: [], //模糊搜索列表
            isSearch: false, //模糊搜索列表是否显示
            page:1,
            column:[], //首页栏目,
            finished:false
        };
    },
    created() {},
    methods: {
        // 点击banner图跳转到详情
        goNewsDetail(item){
            if(item.media_nw===1){
                this.$router.push(item.h5_link)
            } 
        },
        // 进入栏目详情
        goColum(item){
            this.column.map((name,index)=>{
                
                if(item==name&&item.login===0){
                     this.$router.push(item.h5_url);
                     
                }
                if(item==name&&item.login===1){
                    if(this.$store.state.userInfo.user_id==undefined){
                          this.$router.push('/login');
                    }else{
                          this.$router.push(item.h5_url);
                    }   
                }
            })
           
        },
         // 早班车
    goEarly(e) {
       this.$router.push({
           path:"/index/indexcars",
           query:{
               id:e
           }
       })
    },
    // 普通新闻
    goNews(e) {
       
       this.$router.push({
           path:"/index/indexNews",
           query:{
               id:e
           }
       })
    },
    // 进入视频页
    goVedio(e){
        
       this.$router.push({
           path:"/videoDetail",
           query:{videoId:e.id}
       })
    },
    // 首页的上拉加载
     onLoad() {
            this.page = this.page + 1;
                httpPost("/index/index", {
                    province: this.$store.state.areaInfo.pid,
                    page: this.page
                }).then(res => {
                   
                    if (res.code === 1) {
                        this.newsList = [
                            ...this.newsList,
                            ...res.indexlist
                        ];
                        // this.$toast.loading({
                        //     message: "",
                        //     forbidClick: true
                        // });
                    }else{
                        this.finished=true;
                    }
                    
                });
        },
        // 去地址选择页
        goDizhi() {
            this.$router.push("/address");
        },
        // 加载新闻列表
        loadnewsList() {
            httpPost("/index/index", {
                user_id: this.$store.state.userInfo.user_id
            }).then(res => {
              
                if (res.code === 1) {
                    this.newsList = res.indexlist;
                    this.topnewsList = res.topnewslist;
                }
            });

            httpPost("/ad/rotation_index", {
                user_id: this.$store.state.userInfo.user_id,
                province: this.$store.state.areaInfo.pid
            }).then(res => {
                
                if (res.code === 1) {
                    this.bannerList = res.banlist;
                }
            });
        },
        // 获取首页栏目数据
        fetchColumn(){
             httpPost("/index/h5_column", {
                province: this.$store.state.areaInfo.pid
            }).then(res => {
               console.log(res);
                if (res.code === 1) {
                    this.column = res.list;
                }
            });
        },
        // 监听搜索框，请求模糊查询结果
        shuru() {
            var keyword = this.seaValue;
            if (keyword.length >= 2) {
                httpPost("/index/search", {
                    keyword: keyword
                }).then(res => {
                   
                    if (res.code === 1) {
                        this.searchList = res.list;
                        this.isSearch = true;
                    }
                });
            }
        },
        //搜索跳转
        goSchool(item) {
        
            this.$router.push({ path: "/schoolList",query:{
                name:item.name
            } });
        }
    },
    mounted() {
        this.fetchColumn();
        this.loadnewsList();
    }
};
</script>

<style scoped>
input{
  line-height:normal
}
.van-swipe{
    width: 100%;
    height:13.375rem;
}
.head {
    padding: 1rem 0;
    display: flex;
    background: #22d9d9;
    color: #fff;
    line-height: 0rem;
    font-size: 1rem;
}

.province {
    text-align: center;
    font-size: 1.7rem;
    padding: 0.4rem 0.6rem 0 0.6rem;
}

.input {
    width: 80vw;
    position: relative;
    border: 0.08rem #fff solid;
    border-radius: 2rem;
    display: flex;
}
input::-webkit-input-placeholder {
    color: #fff;
   /* 字体大小直接写样式即可 */
    font-size: 14px;
    line-height: 2.25rem;
}
.select-province {
    font-size: 0.8rem;
    padding: 1.1rem 0.3rem;
    border-right: 0.08rem #fff solid;
}

.search {
    position: absolute;
    top: 0.4rem;
    bottom: 0;
    right: 0.7rem;
    font-size: 1.6rem;
}

.input input {
    border: none;
    background: #22d9d9;
    width: 73%;
    /* margin-left:1rem; */
    padding: 0.2rem;
    color: #fff;
}

.searchList {
    position: absolute;
    width: 65vw;
    background: #fff;
    right: 0;
    top: 2.3rem;
    z-index: 100;
    padding: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
}

.searchList li {
    font-size: 0.8rem;
    line-height: 1.8rem;
    color: #000000;
}

img {
    width: 100%;
    height: 100%;
}

.menu {
    width: 96vw;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    text-align: center;
}

.item {
    width: 23vw;
    margin: 1rem 0;
}


.menu-item {
    width: 3rem;
    height: 3rem;
    margin-top: 1rem;
    margin: 0 auto;
}
.menu-item img{
    border-radius: 50%;
}

/*头条*/
.toutiao {
    width: 96vw;
    height: 3rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    border: #f0f0f0 1px solid;
    border-radius: 10px;
    box-shadow: 0 3px 10px -1px #ccc;
}

.toutiao .ttLeft {
    width: 20%;
    text-align: center;
}
.ttLeft img{
    width: 1.875rem;
    display: inline;
}
.ttRight {
    width: 80%;
    height: 100%;
}

.toutiao .swiper {
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.toutiao .van-swipe-item {
    display: flex;
    align-items: center;
    height: 100%;
    color: #888888;
}

.circle {
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 0.2rem;
    background: #888888;
    margin-right: 0.4rem;
}
/* 新闻列表 */

.news-list {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 1.875rem;
}

/* 新闻早班车 */

.earlybus-item {
    padding: 0.5rem;
    margin-bottom: 0.625rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    box-shadow: 0.0625rem 0.125rem 0.125rem 0.0625rem rgba(0, 0, 0, 0.1);
    border-radius: 0.125rem;
}
.single-img {
    width: 7.5rem;
    height: 6.25rem;
    margin: auto 0;
    border-radius: 0.125rem;
}
.monring{
     width: 100%;
    height: 7.5rem;
    padding: 0 0.625rem;
    margin-top: 4px;
}
.earlybus-info {
    width: 100%;
    height: 100%;
    box-shadow: 0.0625rem 0.125rem 0.125rem 0.0625rem rgba(0, 0, 0, 0.1);
    border-radius: 0.125rem;
    background: url('https://new.schoolpi.net/attach/small_program/index/earlyNews.png');
    background-size: 100%;
    margin-bottom: 0.625rem;
}

.single-info {
    width: 12.5rem;
    padding: 0.625rem;
}

.earlybus-title, .triple-title, .nopic-title,.vedio-title {
    font-size: 0.9375rem;
    margin-bottom: 0.3125rem;
}

.earlybus-desc {
    height: 3.125rem;
    overflow: hidden;
    font-size: 0.75rem;
    color: #888;
}

.triple-item {
    padding: 0.5rem;
    margin-bottom: 0.625rem;
    box-sizing: border-box;
    box-shadow: 0.0625rem 0.0625rem 0.125rem 0.0625rem rgba(0, 0, 0, 0.1);
    border-radius: 0.125rem;
}
.triple-title{
    padding: 0.625rem;
}
.triple-content {
    display: flex;
    justify-content: space-between;
}
.triple-img {
    width: 6.25rem;
    height: 5.625rem;
    border-radius: 0.125rem;
}
.nopic-item,.vedio-item {
    padding:1.125rem 0.625rem 0.5rem 0.625rem;
    margin-bottom: 0.625rem;
    box-sizing: border-box;
    box-shadow: 0.0625rem 0.0625rem 0.125rem 0.0625rem rgba(0, 0, 0, 0.1);
    border-radius: 0.125rem;
}
.vedio-img{
    width:100%;
    height: 10.625rem;
    margin-top: 0.3125rem;
}
.nopic-content {
    font-size: 0.75rem;
    color: #888;
}
</style>
